import { render, staticRenderFns } from "./SharedMaterial.vue?vue&type=template&id=7331976d&"
import script from "./SharedMaterial.vue?vue&type=script&lang=js&"
export * from "./SharedMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SharedMaterial.vue?vue&type=style&index=0&id=7331976d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports